import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}

/**
 * PageLayout Component
 * Standard wrapper for all pages to ensure consistent spacing,
 * theme backgrounds, and header offsets.
 */
export const PageLayout: React.FC<PageLayoutProps> = ({ 
  children, 
  className = "",
  fullWidth = false 
}) => {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
        className={`min-h-[calc(100vh-var(--header-height))] bg-theme-bg text-theme-text-primary pt-[var(--header-height)] theme-transition ${className}`}
      >
        <main className={fullWidth ? "w-full" : "w-full"}>
          {children}
        </main>
      </motion.div>
    </AnimatePresence>
  );
};

export default PageLayout;
